export default function Hero() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img 
          src="https://public.readdy.ai/ai/img_res/e0880b6cdd116227f81c7191c6b14c51.jpg" 
          alt="Digitization workspace" 
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 py-32 w-full">
        <div className="max-w-3xl">
          <div className="inline-block mb-6">
            <span className="px-5 py-2 rounded-full border border-white/50 text-white text-sm font-medium backdrop-blur-sm whitespace-nowrap">
              Legacy Media Preservation Experts
            </span>
          </div>

          <h1 className="text-6xl md:text-7xl lg:text-8xl font-light text-white mb-6 leading-tight" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
            Transform Your
            <br />
            Legacy Media Into
            <br />
            Digital Excellence
          </h1>

          <p className="text-lg md:text-xl text-white/90 mb-10 max-w-2xl leading-relaxed">
            Expert digitization services for microfilm, microfiche, bound materials, and virtually any legacy media. Preserve your valuable archives with precision and care.
          </p>

          <div className="flex flex-wrap gap-4">
            <button onClick={() => scrollToSection('booking')} className="bg-[#D97706] text-white px-8 py-4 rounded-full text-base font-medium hover:bg-[#B45309] transition-all hover:scale-105 whitespace-nowrap">
              Schedule Consultation <i className="ri-arrow-right-line ml-2"></i>
            </button>
            <button onClick={() => scrollToSection('services')} className="bg-white/20 backdrop-blur-sm text-white px-8 py-4 rounded-full text-base font-medium hover:bg-white/30 transition-all border border-white/30 whitespace-nowrap">
              Explore Services
            </button>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white text-3xl opacity-70"></i>
      </div>
    </section>
  );
}
